import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppConfig } from '@mkp/shared/util-app-config';

const { routes } = AppConfig;

export const hasTokenInUrl = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const token = route.queryParamMap.get('token') ?? undefined;

  return !!token || router.parseUrl(routes.error404);
};
